export const CLASSIFICATION_COLUMN_IDS = {
  GROUP_CLASS: "GROUP_CLASS",
  CREATED_ON: "CREATED_ON",
  CREATED_BY: "CREATED_BY",
  ACTIONS: "ACTIONS",
  ICON: "ICON",
} as const;
